import { FC } from 'react'
import { Button, FlexboxGrid } from 'rsuite'
import Link from 'next/link'
import useTranslation from 'next-translate/useTranslation'

import useUrls from '../../services/useUrls'
import { OrderList } from '../../utils/types/buyerCatalogs'
import { getCatalogLink, getPickedSuppliers } from '../../lib/userCatalog'
import UserPopover from '../BuyerProfile/UserPopover'

import styles from '../../styles/CatalogCardMobile.module.less'
import buttonStyles from '../../styles/CustomButtons.module.less'

interface CatalogCardMobileProps {
  catalog: OrderList
}

const CatalogCardMobile: FC<CatalogCardMobileProps> = ({ catalog }) => {
  const { editor, owner, items, name, ownerStatus, id } = catalog

  const { urlT } = useUrls()
  const { t } = useTranslation('buyerProfile')

  const actualOwner = editor || owner
  const titleText = t('Created by {{ owner }}', { owner: actualOwner })
  const userShortTitle = !editor && ownerStatus === 0 ? (
    <>
      {titleText}
      <br />
      <span>
        {t('User has been disabled')}
      </span>
    </>
  ) : titleText

  return (
    <div className={styles['catalog-card-mobile']}>
      <FlexboxGrid
        className={styles['inner-section']}
        justify="space-between"
      >
        <FlexboxGrid.Item className="flex-shrink-col-dynamic">
          <h5>{name}</h5>
          <p className="margin-top-spacer">
            {`${t('Picked products')}: ${
              items.length
            }`}
          </p>
          <p>{`${t('Selected suppliers')}: ${getPickedSuppliers(items, t)}`}</p>
        </FlexboxGrid.Item>
        <FlexboxGrid.Item>
          <UserPopover
            fullName={actualOwner || ''}
            hover
            isAdmin={false}
            title={userShortTitle}
            placement="left"
          />
        </FlexboxGrid.Item>
      </FlexboxGrid>

      <Link
        href={urlT(getCatalogLink(id, name))}
        shallow
      >
        <Button
          appearance="primary"
          className={`${buttonStyles['custom-button']} ${buttonStyles['button-primary']} ${buttonStyles['button-caret']}`}
          block
        >
          {t('View')}
        </Button>
      </Link>
    </div>
  )
}

export default CatalogCardMobile
